(function () {
    'use strict';
    var m = angular.module('dashboard');
    m.factory('dashboardSecurityStackV2Logic', function () {
        return function ($scope, logic) {
            var watcher = _.noop;
            var sliderWidget = _($scope.model.widgets).find(function (widget) {
                return widget.logic && widget.logic.name === 'modulesStatsLogic';
            });
            if (sliderWidget) {
                watcher = $scope.$watch(function () {
                    return sliderWidget.widgets && sliderWidget.widgets.length;
                }, function (val) {
                    if ($scope.model.logic.hideAnalyticsSecurityStack) {
                        $scope.model.wrapper['class']['display-none'] = true;
                    } else {
                        $scope.model.wrapper['class']['display-none'] = false;
                        if (val === 0 || val) {
                            $scope.model.wrapper.showLoading = false;
                            $scope.model.wrapper.isLoading = false;
                        } else {
                            $scope.model.wrapper.showLoading = true;
                            $scope.model.wrapper.isLoading = true;
                        }
                    }
                });
            }
            return watcher;
        };
    });
}());